import * as React from "react";
const SvgTrash = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "5em", fillRule: "evenodd", "aria-hidden": "true", clipRule: "evenodd", style: {
  height: "1.5em"
}, viewBox: "0 0 23 23", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", stroke: "currentColor", strokeWidth: 0.25, d: "M19 24H5a2 2 0 0 1-2-2V5H2V3h6V1.5C8 .673 8.673 0 9.5 0h5c.825 0 1.5.671 1.5 1.5V3h6v2h-1v17a2 2 0 0 1-2 2zm0-19H5v16.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5zm-7 7.586 3.293-3.293 1.414 1.414L13.414 14l3.293 3.293-1.414 1.414L12 15.414l-3.293 3.293-1.414-1.414L10.586 14l-3.293-3.293 1.414-1.414zM14 2h-4v1h4z" }));
export {
  SvgTrash as default
};
//# sourceMappingURL=trash.js.map
